import { connect } from 'react-redux';

import { appTriggers } from 'app/developer-v3/selectors';
import { deleteTrigger } from 'app/developer-v3/Actions';

import TriggersPage from './TriggersPage';

const mapStateToProps = state => {
  return {
    triggers: appTriggers(state),
  };
};

export default connect(mapStateToProps, { deleteTrigger })(TriggersPage);
